// vuex/modules/auth/store.js
import axios from "axios"

let Config = {}
try {
  Config = require("/config.js").default
} catch (err) {
  console.log("Auth Service: Couldn't find module config, using adc-web-components config")
  Config = require("/config.js").default
}

axios.defaults.withCredentials = true

const AuthService = {
  namespaced: true,
  state: {
    token: "",
    loggedIn: false,
    userName: "",
    personId: "",
    warningMsg: false,
    accountExpired: false,
    accountExpiredMsg: "Account expired",
    personName: "",
  },
  getters: {
    getLoggedIn: state => {
      return state.loggedIn
    },
    getPersonId: state => {
      return state.personId
    },
    getUserName: state => {
      return state.userName
    },
    showWarningMsg: state => {
      return !!state.warningMsg
    },
    getWarningMsg: state => {
      return state.warningMsg
    },
    getPersonName: state => {
      return state.personName
    },
    getAccountExpired: state => {
      return state.accountExpired
    },
    getAccountExpiredMsg: state => {
      return state.accountExpiredMsg
    },
  },
  mutations: {
    setWarningMsg(state, warningMsg) {
      state.warningMsg = warningMsg
    },
    setUserInfo(state, response) {
      //console.log("setUserInfo response", response)
      state.userName = response.data.userName
      state.personId = response.data.personId.toString()
      state.personName = `${response.data.nameFirst} ${response.data.nameLast}`
      state.loggedIn = true
      state.token = ""
      state.warningMsg = ""
      state.accountExpired = false
    },
    setAccountExpired(state, value) {
      state.accountExpired = value
    },
    resetState(state) {
      state.token = ""
      state.personName = ""
      state.userName = ""
      state.personId = ""
      state.loggedIn = false
    },
  },
  actions: {
    basicLogin({ commit, state, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios({
          url: `${Config.auth.authService}/login?service=${Config.auth.serviceName}`,
          method: "post",
          headers: {
            Authorization: `Basic ${btoa(`${payload.username}:${payload.password}`)}`,
          },
          //withCredentials: false,
        })
          .then((response) => {
            //console.log("[Basic Login]", response)
            commit("setUserInfo", response)
            resolve(response)
          })
          .catch(error => {
            //console.log("Error", error.response)
            if (error.response.status === 401) {
              commit("setWarningMsg", "Invalid Credentials!")
              if (state.accountExpired) commit("setAccountExpired", false)
            } else if (error.response.status === 403) {
              if (error.response.data === state.accountExpiredMsg) {
                commit("setAccountExpired", true)
                commit("setWarningMsg", "Account expired!")
              } else {
                if (state.accountExpired) commit("setAccountExpired", false)
                commit("setWarningMsg", "Invalid Session!")
              }
            } else {
              commit("setWarningMsg", "Login Error")
              commit("setAccountExpired", false)
            }
            reject(error)
          })
      })
    },
    login({ commit, state }) {
      var url = window.location.href
      if (url.indexOf("ticket") > 0) {
        var ticket = url.split("?ticket=")[1].split("#/")[0]
        state.token = ticket
        // Ajax
        return new Promise((resolve, reject) => {
          axios.get(`${Config.auth.authService}login?ticket=${ticket}`)
            .then((response) => {
              if (response.data) {
                resolve(response)
                commit("setUserInfo", response)
                commit("setWarningMsg", "")
              }
            }).catch(error => {
              reject(error)
              if (error.response.status === 403 && error.response.data === state.accountExpiredMsg) {
                commit("setAccountExpired", true)
                commit("setWarningMsg", "Account expired!")
              }
            })
        })
      }
    },
    logout({state, commit}) {
      if (state.loggedIn) {
        // Ajax
        return new Promise((resolve, reject) => {
          axios({
            url: `${Config.auth.authService}logout`,
            method: "GET",
            withCredentials: true,
          })
            .then((response) => {
              if (response.data) {
                commit("resetState")
                resolve(response)
              }
            }).catch(error => {
              commit("resetState")
              reject(error)
            })
        })
      }
    },
    validateUserSession({commit}) {
      return new Promise((resolve, reject) => {
        axios.get(`${Config.auth.authService}login`)
          .then((response) => {
            if (response.data && response.data.personId) {
              commit("setUserInfo", response)
              commit("setWarningMsg", "")
              resolve(response)
            }
          }).catch(error => {
            reject(error)
          })
      })
    },
    init ({ dispatch }) {       // Could also be async and use await instead of return
      return Promise.all([
        dispatch("validateUserSession"), // Using another action
      ])
    },
    warningMsg(context, value) {
      context.commit("setWarningMsg", value)
    },
  },
}

export default AuthService
